export const document = {
  type: "Document Type",
  number: "Document Number",
  numberPlaceholder: "e.g., PRO-2024-001",
  auto: "Auto",
  buttons: {
    updateDocument: "Update Document",
    addDocument: "Add Document",
  }
}
